import { FeedbackButtonStateType } from '../../../../../../components/feedbackButton/types/feedbackButtonStateType';
import { FeedbackButtonVariantType } from '../../../../../../components/feedbackButton/types/feedbackButtonVariantType';
export const getPositiveStyles = (FOUNDATIONS, FONT, SHADOWS) => {
    return {
        [FeedbackButtonVariantType.POSITIVE]: {
            [FeedbackButtonStateType.DEFAULT]: {
                container: {
                    width: FOUNDATIONS.size_300,
                    height: FOUNDATIONS.size_300,
                    display: 'flex',
                    flex_direction: 'row',
                    justify_content: 'center',
                    align_items: 'center',
                    border_radius: FOUNDATIONS.radius_comp_forms_pill_radiussize,
                    border: `${FOUNDATIONS.border_50} solid ${FOUNDATIONS.color_comp_actions_feedbackbutton_default_bg}`,
                    background_color: FOUNDATIONS.color_comp_actions_feedbackbutton_default_bg,
                    box_shadow: SHADOWS.shadow_30,
                    cursor: 'pointer',
                },
                icon: {
                    color: FOUNDATIONS.color_comp_actions_feedbackbutton_default_icon,
                    width: '14px',
                    height: '14px',
                },
            },
            [FeedbackButtonStateType.SELECTED]: {
                container: {
                    width: FOUNDATIONS.size_300,
                    height: FOUNDATIONS.size_300,
                    display: 'flex',
                    flex_direction: 'row',
                    justify_content: 'center',
                    align_items: 'center',
                    border_radius: FOUNDATIONS.radius_comp_forms_pill_radiussize,
                    border: `${FOUNDATIONS.border_50} solid ${FOUNDATIONS.color_comp_actions_feedbackbutton_positive_border}`,
                    background_color: FOUNDATIONS.color_comp_actions_feedbackbutton_positive_bg,
                    box_shadow: SHADOWS.shadow_30,
                    cursor: 'pointer',
                },
                icon: {
                    color: FOUNDATIONS.color_comp_actions_feedbackbutton_positive_icon,
                    width: '14px',
                    height: '14px',
                },
            },
        },
    };
};
//# sourceMappingURL=positive.js.map